export default "__VITE_ASSET__CDJSds5Z__"